export const GCP_BUCKET = 'https://storage.googleapis.com/datalooksdope'
